import React, { ReactNode } from 'react'
import { Heading, Text} from 'base-ui'
import { IconCheckCircle } from '@paro.io/base-icons'


interface CardProps {
    children: ReactNode
    className?: string
    title: string
    isResponsive?: boolean
  }
  
  export const PageWrapper = ({ children, className, title, isResponsive }: CardProps) => {
    return (
        <div className={`${className} bg-white rounded-md p-16 relative`}>
          {isResponsive
            ? <Text  size="sm" className='text-success-darker absolute top-2 right-4'><IconCheckCircle className='p-1 inline'/> Responsive</Text>
            : ""
          }
            <Heading size="h1" className='mb-8'>{title}</Heading>
            {children}
        </div>
    )
  }
  